<template>
  <div class="help-container">
    <!-- Help Introduction -->
    <div class="help-introduction">
      <h2>{{ $t('help.portalName') }}</h2>
      <p v-html="$t('help.introduction')"></p>
    </div>

    <!-- FAQ section -->
    <ul class="help-list">
      <li v-for="(question, index) in questions" :key="index">
        <!-- Question -->
        <div class="help-item" @click="toggleAnswer(index)">
          <span> {{ $t(question.title) }} </span>
          <span class="help-toggle"> {{ question.open ? "-" : "+" }}</span>
        </div>

        <!-- Answer -->
        <div v-show="question.open" class="help-answer">
          <p v-html=" $t(question.answer)"></p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'HelpManagement',
  data() {
    return {
      questions: [
        {title: 'help.question1.title', answer: 'help.question1.answer'},
        {title: 'help.question2.title', answer: 'help.question2.answer'},
        {title: 'help.question3.title', answer: 'help.question3.answer'},
        {title: 'help.question4.title', answer: 'help.question4.answer'},
        {title: 'help.question5.title', answer: 'help.question5.answer'},
        {title: 'help.question6.title', answer: 'help.question6.answer'},
        {title: 'help.question7.title', answer: 'help.question7.answer'},
        {title: 'help.question9.title', answer: 'help.question9.answer'},
        {title: 'help.question10.title', answer: 'help.question10.answer'},
        {title: 'help.question11.title', answer: 'help.question11.answer'},
        {title: 'help.question12.title', answer: 'help.question12.answer'},
        {title: 'help.question13.title', answer: 'help.question13.answer'},
        {title: 'help.question14.title', answer: 'help.question14.answer'},
        {title: 'help.question15.title', answer: 'help.question15.answer'},
      ],
    };
  },
  methods: {
    toggleAnswer(index) {
      this.questions[index].open = !this.questions[index].open;
    }
  }
};
</script>

<style scoped>
.version-label {
  padding: 15px;
  text-align: end;
}
</style>

